import React from 'react'
import { Helmet } from 'react-helmet-async'
import type { Metadata } from 'next'
import ServicePageTemplate, { ServicePageConfig } from '@/components/templates/ServicePageTemplate'

export const metadata: Metadata = {
  title: 'Private Jet Charter | Member Services | FGA Prestige',
  description: 'Luxury private aviation with global reach. On-demand private jet charters for flexible, secure, and comfortable worldwide travel.',
  openGraph: {
    title: 'Private Jet Charter | Member Services | FGA Prestige',
    description: 'Luxury private aviation with global reach. On-demand private jet charters for flexible, secure, and comfortable worldwide travel.',
    url: 'https://fgaprestige.com/member-services/private-jet-charter',
    images: [
      {
        url: '/Member Services/Private Jet Charter/hero.png',
        width: 1200,
        height: 630,
        alt: 'FGA Prestige Private Jet Charter',
      },
    ],
  },
}

const privateJetConfig: ServicePageConfig = {
  title: 'Private Jet Charter - FGA Prestige',
  description: 'Luxury private aviation services with global reach.',
  slug: 'private-jet-charter',
  heroImage: '/Member Services/Private Jet Charter/hero.png',
  serviceName: 'PRIVATE JET CHARTER',
  whySectionA: {
    title: 'Above and Beyond',
    content: 'Step into a world where the sky is not the limit—it’s just the beginning. Our Jet Charter Service redefines what it means to travel privately, offering you a seamless blend of speed, sophistication, and service that’s always a cut above the clouds.',
    image: '/Member Services/Private Jet Charter/body/1.png',
    imageAlt: 'Ultra-luxury Private Jet Interior'
  },
  whySectionC: {
    title: 'Fleet of Dreams',
    content: 'Choose from an unrivaled collection of private jet models, each designed to match your mission and your mood. Whether you desire the nimble agility of the Embraer Phenom 300, the spacious comfort of the Cessna Citation Latitude, or the globe-trotting luxury of the Bombardier Global 7500, our fleet is as diverse as your destinations. Every aircraft is meticulously maintained and ready to whisk you away at a moment\'s notice.',
    image: '/Member Services/Private Jet Charter/body/2.png',
    imageAlt: 'Ultra-luxury Private Jet Interior'
  },
  whySectionB: {
    title: 'Elevated Tastes',
    benefits: [
      {
        title: '',
        description: 'Indulge in a culinary experience that soars as high as you do. Our bespoke catering brings the world\'s flavors to your table at 40,000 feet, crafted by top chefs and tailored to your preferences. Whether you crave a Michelin-starred menu, regional specialties, or simply the perfect glass of champagne, every bite is a celebration of taste and luxury. With over 2,000 catering partners worldwide and a Signature Selection Menu, your journey is as delicious as it is distinguished.'
      }
    ],
    image: '/Member Services/Private Jet Charter/body/3.png',
    imageAlt: 'Private Aviation Fleet Services'
  },
  masterpieceBackgroundImage: '/Member Services/Private Jet Charter/CTA Banner/banner.png'
}

export default function PrivateJetCharterPage() {
  return (
    <>
      <Helmet>
        <title>Private Jet Charter | Member Services | FGA Prestige</title>
        <meta name="description" content="Luxury private aviation with global reach. On-demand private jet charters for flexible, secure, and comfortable worldwide travel." />
        <link rel="canonical" href="https://fgaprestige.com/member-services/private-jet-charter" />
        <meta property="og:title" content="Private Jet Charter | Member Services | FGA Prestige" />
        <meta property="og:description" content="Luxury private aviation with global reach. On-demand private jet charters for flexible, secure, and comfortable worldwide travel." />
        <meta property="og:url" content="https://fgaprestige.com/member-services/private-jet-charter" />
        <meta property="og:image" content="/Member Services/Private Jet Charter/hero.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:alt" content="FGA Prestige Private Jet Charter" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Private Jet Charter | Member Services | FGA Prestige" />
        <meta name="twitter:description" content="Luxury private aviation with global reach. On-demand private jet charters for flexible, secure, and comfortable worldwide travel." />
        <meta name="twitter:image" content="/Member Services/Private Jet Charter/hero.png" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            "name": "Private Jet Charter",
            "description": "Luxury private aviation with global reach. On-demand private jet charters for flexible, secure, and comfortable worldwide travel.",
            "provider": {
              "@type": "Organization",
              "name": "FGA Prestige",
              "url": "https://fgaprestige.com"
            },
            "url": "https://fgaprestige.com/member-services/private-jet-charter",
            "image": "/Member Services/Private Jet Charter/hero.png"
          })}
        </script>
      </Helmet>
      <ServicePageTemplate config={privateJetConfig} />
    </>
  )
}